module.exports = __webpack_public_path__ + "static/west-jet-logo-de2308982c5dd7a0edc80e604f2571a4.jpg";